import React, { useState } from "react";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const EMPTY = { name: "", whatsapp: "", instagram: "", email: "", customer_type: "Personal", source: "Instagram DM", notes: "" };
const SOURCES = ["Instagram DM", "WhatsApp", "Returning Customer", "Community", "Corporate", "Café Partner", "Offline", "Website", "Other"];
const sel = "w-full h-10 rounded-md border border-input bg-white px-3 text-sm";

export const AddCustomerDialog = ({ onCreated }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const r = await api.post("/customers", f);
      toast.success(`${r.data.name} ditambahkan (${r.data.customer_no})`);
      setF(EMPTY); setOpen(false); onCreated?.(r.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gagal menambah customer");
    } finally { setBusy(false); }
  };

  return (
    <>
      <button data-testid="add-customer-btn" onClick={() => setOpen(true)}
        className="lm-btn-primary rounded-md px-4 py-2.5 text-sm font-semibold flex items-center gap-2">
        <UserPlus size={15} /> Tambah Customer
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[85vh] overflow-y-auto">
          <DialogHeader><DialogTitle>Tambah Customer Manual</DialogTitle></DialogHeader>
          <div className="grid sm:grid-cols-2 gap-4" data-testid="add-customer-form">
            <label className="block"><span className="text-[11px] uppercase tracking-widest text-ink-soft">Nama lengkap</span>
              <Input className="mt-1" data-testid="ac-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
            </label>
            <label className="block"><span className="text-[11px] uppercase tracking-widest text-ink-soft">WhatsApp</span>
              <Input className="mt-1" data-testid="ac-wa" placeholder="0812xxxxxxx" value={f.whatsapp} onChange={(e) => setF({ ...f, whatsapp: e.target.value })} />
            </label>
            <label className="block"><span className="text-[11px] uppercase tracking-widest text-ink-soft">Instagram</span>
              <Input className="mt-1" data-testid="ac-ig" value={f.instagram} onChange={(e) => setF({ ...f, instagram: e.target.value })} />
            </label>
            <label className="block"><span className="text-[11px] uppercase tracking-widest text-ink-soft">Email</span>
              <Input className="mt-1" data-testid="ac-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
            </label>
            <label className="block"><span className="text-[11px] uppercase tracking-widest text-ink-soft">Tipe</span>
              <select className={`${sel} mt-1`} data-testid="ac-type" value={f.customer_type} onChange={(e) => setF({ ...f, customer_type: e.target.value })}>
                <option value="Personal">Personal</option><option value="Corporate">Corporate</option>
              </select>
            </label>
            <label className="block"><span className="text-[11px] uppercase tracking-widest text-ink-soft">Sumber</span>
              <select className={`${sel} mt-1`} data-testid="ac-source" value={f.source} onChange={(e) => setF({ ...f, source: e.target.value })}>
                {SOURCES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </label>
            <label className="sm:col-span-2 block"><span className="text-[11px] uppercase tracking-widest text-ink-soft">Catatan</span>
              <Textarea className="mt-1" rows={2} data-testid="ac-notes" value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} />
            </label>
            <div className="sm:col-span-2 flex gap-2">
              <button data-testid="ac-save" disabled={busy} onClick={save} className="lm-btn-primary rounded-md px-5 py-2.5 text-sm font-semibold disabled:opacity-50">
                {busy ? "Menyimpan…" : "Simpan"}
              </button>
              <button onClick={() => setOpen(false)} className="rounded-md px-5 py-2.5 text-sm border border-black/15">Batal</button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
